import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/common/img-pagetop.svg'


const _hoisted_1 = { class: "l-wrapper_nav" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "p-jobsearch-bulkselection_inner" }

import { Job } from '@/types';

 // definePropsをインポート
import { RouterLink } from 'vue-router';
import { domHelperUtils } from '@/utils/domHelper';
import { MYPAGE_CONSTANTS } from '../constants/mypage';


export default /*#__PURE__*/_defineComponent({
  __name: 'PendingFooter',
  props: {
    isBulkSelectionEnabled: { type: Boolean },
    jobs: null,
    isLoading: { type: Boolean }
  },
  emits: ['action'],
  setup(__props: any, { emit }) {



function scrollToTop() {
  domHelperUtils.scrollToTop();
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("a", {
      class: "g-pagetop",
      href: "#",
      "aria-label": "ページトップへ戻る",
      onClick: _withModifiers(scrollToTop, ["prevent"])
    }, _hoisted_4, 8, _hoisted_2), [
      [_vShow, !__props.isLoading]
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["p-jobsearch-bulkselection p-pending_bulkselection", {'--fixed': __props.isBulkSelectionEnabled}])
    }, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_unref(RouterLink), {
          class: "p-jobsearch-btn __blue __bulkselection",
          to: { path: '/apply/multiple', query: { screen: _unref(MYPAGE_CONSTANTS).SCREN_NAME_MULTI_APPLY.PENDING, orderIds: __props.jobs?.filter(v => v.checked).map(v => v.orderId) } }
        }, {
          default: _withCtx(() => [
            _createTextVNode("一括応募する")
          ]),
          _: 1
        }, 8, ["to"]),
        _createElementVNode("button", {
          class: "p-jobsearch-btn __do-not-apply",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('action')))
        }, "応募しない")
      ])
    ], 2)
  ]))
}
}

})